
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { httpClient } from "infra/axios/axios-api";
import Spinner from "presentation/components/Shared/Spinner";
import { useIsMobile } from "presentation/mobile/hooks/useIsMobile";

/**
 * Propriedades para o componente ImageViewerDialog.
 */
interface ImageViewerDialogProps {
    /** Função de callback chamada quando o diálogo é fechado. */
    onHide: () => void;
    /** O caminho do S3 para o ficheiro de imagem a ser exibido. */
    s3Path: string | null;
}

/**
 * Um componente de diálogo reutilizável para exibir ficheiros de imagem via S3.
 * Ele encapsula a lógica de carregamento da imagem e o gerenciamento da URL do objeto Blob.
 */
const MobileImageViewerDialog: React.FC<ImageViewerDialogProps> = ({
    onHide,
    s3Path,
}) => {
    const [internalImageUrl, setInternalImageUrl] = useState<string | null>(null);
    const [isLoadingImage, setIsLoadingImage] = useState(false);
    const [errorImage, setErrorImage] = useState<string | null>(null);

    const isMobile = useIsMobile();

    useEffect(() => {
        let objectUrl: string | null = null;

        const fetchImage = async () => {
            if (s3Path) {
                setIsLoadingImage(true);
                setErrorImage(null);
                setInternalImageUrl(null);
                try {
                    const fileStreamResponse = await httpClient.get(
                        `/assets/download/${s3Path}`,
                        {
                            responseType: "blob",
                        }
                    );

                    const contentType = fileStreamResponse.headers["content-type"];

                    // Cria um Blob com o tipo genérico de imagem ou o tipo retornado
                    const imageBlob = new Blob([fileStreamResponse.data], {
                        type: typeof contentType === "string" ? contentType : "image/jpeg",
                    });
                    objectUrl = URL.createObjectURL(imageBlob);
                    setInternalImageUrl(objectUrl);
                } catch (err) {
                    console.error("Erro ao carregar Imagem do S3:", err);
                    setErrorImage("Não foi possível carregar a imagem.");
                } finally {
                    setIsLoadingImage(false);
                }
            }
        };

        fetchImage();

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [s3Path]);

    const handleHide = () => {
        onHide();
    };
    console.log(internalImageUrl);
    return (
        <Dialog
            header="Visualizador de Imagem"
            visible={!!s3Path}
            style={{ width: "70vw", height: "90vh" }}
            onHide={handleHide}
            maximized={isMobile}
            maximizable
            contentStyle={{backgroundColor: "#ebebeb"}}
        >
            {isLoadingImage && <Spinner />}
            {errorImage && <div className="p-error">{errorImage}</div>}
            {!isLoadingImage && !errorImage && internalImageUrl && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <img
                        src={internalImageUrl}
                        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                        alt="Visualização"
                    />
                </div>
            )}
            {!isLoadingImage && !s3Path && <div>Nenhuma imagem para exibir.</div>}
        </Dialog>
    );
};

export default MobileImageViewerDialog;
